import { render } from "./UserLinkNavigationContainer.vue?vue&type=template&id=0ee507b0"
const script = {}

import "./UserLinkNavigationContainer.vue?vue&type=style&index=0&id=0ee507b0&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserLinkNavigationContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ee507b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ee507b0', __exports__)) {
    console.log('reload')
    api.reload('0ee507b0', __exports__)
  }
  
  module.hot.accept("./UserLinkNavigationContainer.vue?vue&type=template&id=0ee507b0", () => {
    console.log('re-render')
    api.rerender('0ee507b0', render)
  })

}


export default __exports__